<template>
    <rkm-modal
        :buttons="['cancel', 'save']"
        buttonSaveText="Cancelar FAA"
        buttonSaveColor="danger"
        :loading="loading"
        title="Cancelamento de FAA"
        @save="handleSave"
        extra-large
        ref="Modal"
    >
        <rkm-form
            ref="Form"
        >
            <rkm-alert color="warning" class="text-center">
                A <strong>FAA {{ item.numero }}</strong> do paciente <strong v-if="item.paciente && item.paciente.nome">{{ item.paciente.nome }}</strong> será cancelada!
                <br/> Se deseja continuar com essa ação, informe o motivo e pressione o botão <strong>Cancelar FAA</strong>.
            </rkm-alert>

            <rkm-row>
                <rkm-col>
                    <rkm-form-textarea
                        label="Motivo"
                        v-model="model.motivoCancelamento"
                        placeholder="Digite o motivo que levou a cancelar a FAA"
                        :validations="{ required: true, max: 500, min: 3 }"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>
    </rkm-modal>
</template>

<script>

// Mixins.
import { error, repository } from '@/mixins'

// Vuex.
import { mapActions, mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
    },
    created() {
        this.repositories = {
            fechamentoFaa: this.getConectaSusRepository('prontoAtendimento.fechamentoFaa')
        }
    },
    data: () => ({
        item: {},
        model: {
            motivoCancelamento: ''
        },
        errorMessage: ''
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(item) {
            this.item = item;
            this.$refs.Modal.show()
        },
        handleSave() {
            this.setLoading()

            this.repositories.fechamentoFaa.cancelarFaa(this.item.id, { motivo_cancelamento: this.model.motivoCancelamento })
                .then(({data}) => {
                    if(!data.error) {
                        this.showSaveNotification();
                        this.$emit('cancelado', this.item.id)
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())

            this.$refs.Modal.hide();
            this.model.motivoCancelamento = '';

        },
    },
    mixins: [ error, repository ],
}
</script>
